// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesBetslipsEntityData } from '../../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { type SelectorMaker } from '../../../types/selectors';
import { type BoomSkinId } from '../types/global';
import { type BoomStepId } from '../types/steps';

export const makeHistoryBoomStateSelector: SelectorMaker<unknown | undefined> = () =>
  createSelector([selectEntitiesBetslipsEntityData], (data) => data?.BOOM);

export const makeHistoryBoomIdSelector: SelectorMaker<string | undefined> = () =>
  createSelector([makeHistoryBoomStateSelector()], (boom) => boom?.boomId);

export const makeHistoryBoomSkinIdSelector: SelectorMaker<BoomSkinId | undefined> = () =>
  createSelector([makeHistoryBoomStateSelector()], (boom) => boom?.skinId);

export const makeHistoryBoomStepIdSelector: SelectorMaker<BoomStepId | undefined> = () =>
  createSelector([makeHistoryBoomStateSelector()], (boom) => boom?.stepId);

export const makeHistoryBoomDisabledSelector: SelectorMaker<boolean> = () =>
  createSelector([makeHistoryBoomStateSelector()], (boom) => boom?.disabled);
